import { COLOR2 } from '../../../constants';

export const MultiCountrySelectStyles = {
  searchField: {
    '::placeholder': {
      font: 'normal 700 14px/20px Arial',
      color: '#727578',
    },
  },

  iconRoot: {
    paddingRight: 0,
  },

  inpRoot: {
    width: '95% !important',
  },

  selectedCountry: {
    margin: '12px 0 10px 0',
    font: 'normal 700 14px/20px Arial',
    color: '#661C69',
  },

  selectOutlinedInp: {
    height: '48px',
  },

  select_placeholder: {
    textAlign: 'left',
    boxSizing: 'border-box',
    fontWeight: 400,
    lineHeight: '20px',
    fontStyle: 'normal',
    fontSize: '14px',
    letterSpacing: '0.1px',
    color: '#000000',
    opacity: 0.8,
  },

  chip: {
    background: '#F4EDF4',
    font: 'normal 700 12px/20px Arial',
    color: '#661C69',
    margin: '0 10px 10px 0',
    padding: '0 5px',
    '& .MuiChip-deleteIcon': {
      height: '13.5px',
      width: '13.5px',
    },
  },

  error_message_product: {
    font: 'normal normal normal 14px/16px Arial',
    letterSpacing: '0.1px',
    color: COLOR2,
    opacity: 1,
    marginTop: '4px',
    display: 'block',
  },
};
